var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoCanFee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 64,
    viewBox: "0 0 53 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58203 8.01953C8.58203 6.91496 9.47746 6.01953 10.582 6.01953H43.9953C45.0998 6.01953 45.9953 6.91496 45.9953 8.01953V52.2038L39.7597 46.6617L33.5242 52.2038L27.2887 46.6617L21.0531 52.2038L14.8176 46.6617L8.58203 52.2038V8.01953Z",
    fill: "#D1E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9953 52.2038L44.9988 53.3249L47.4953 55.5438V52.2038H45.9953ZM39.7597 46.6617L40.7562 45.5405L39.7597 44.6548L38.7632 45.5405L39.7597 46.6617ZM33.5242 52.2038L32.5277 53.3249L33.5242 54.2106L34.5207 53.3249L33.5242 52.2038ZM27.2887 46.6617L28.2851 45.5405L27.2887 44.6548L26.2922 45.5405L27.2887 46.6617ZM21.0531 52.2038L20.0566 53.3249L21.0531 54.2106L22.0496 53.3249L21.0531 52.2038ZM14.8176 46.6617L15.8141 45.5405L14.8176 44.6548L13.8211 45.5405L14.8176 46.6617ZM8.58203 52.2038H7.08203V55.5438L9.57852 53.3249L8.58203 52.2038ZM10.582 7.51953H43.9953V4.51953H10.582V7.51953ZM44.4953 8.01953V52.2038H47.4953V8.01953H44.4953ZM46.9918 51.0826L40.7562 45.5405L38.7632 47.7828L44.9988 53.3249L46.9918 51.0826ZM38.7632 45.5405L32.5277 51.0826L34.5207 53.3249L40.7562 47.7828L38.7632 45.5405ZM34.5207 51.0826L28.2851 45.5405L26.2922 47.7828L32.5277 53.3249L34.5207 51.0826ZM26.2922 45.5405L20.0566 51.0826L22.0496 53.3249L28.2851 47.7828L26.2922 45.5405ZM22.0496 51.0826L15.8141 45.5405L13.8211 47.7828L20.0566 53.3249L22.0496 51.0826ZM13.8211 45.5405L7.58555 51.0826L9.57852 53.3249L15.8141 47.7828L13.8211 45.5405ZM10.082 52.2038V8.01953H7.08203V52.2038H10.082ZM43.9953 7.51953C44.2714 7.51953 44.4953 7.74339 44.4953 8.01953H47.4953C47.4953 6.08653 45.9283 4.51953 43.9953 4.51953V7.51953ZM10.582 4.51953C8.64903 4.51953 7.08203 6.08654 7.08203 8.01953H10.082C10.082 7.74339 10.3059 7.51953 10.582 7.51953V4.51953Z",
    fill: "#195EB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6914 13.7598C17.1391 13.7598 16.6914 14.2075 16.6914 14.7598C16.6914 15.3121 17.1391 15.7598 17.6914 15.7598V13.7598ZM18.3294 21.4199V20.4199H15.902L17.6251 22.1297L18.3294 21.4199ZM22.3638 26.832C22.7559 27.221 23.389 27.2186 23.778 26.8266C24.1671 26.4345 24.1646 25.8014 23.7726 25.4124L22.3638 26.832ZM17.6914 15.7598H20.2148V13.7598H17.6914V15.7598ZM20.2148 20.4199H18.3294V22.4199H20.2148V20.4199ZM17.6251 22.1297L22.3638 26.832L23.7726 25.4124L19.0338 20.7101L17.6251 22.1297ZM22.5448 18.0898C22.5448 19.3767 21.5016 20.4199 20.2148 20.4199V22.4199C22.6062 22.4199 24.5448 20.4813 24.5448 18.0898H22.5448ZM20.2148 15.7598C21.5016 15.7598 22.5448 16.803 22.5448 18.0898H24.5448C24.5448 15.6984 22.6062 13.7598 20.2148 13.7598V15.7598Z",
    fill: "#195EB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6992 14.7534H25.9105",
    stroke: "#195EB7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 18.103H25.9773",
    stroke: "#195EB7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7539 16.2539H36.4444",
    stroke: "#195EB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9648 23.6133H38.7742",
    stroke: "#195EB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7109 32.4677H39.0428",
    stroke: "#195EB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7109 39.5712H39.0428",
    stroke: "#195EB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 60.6159L49.5358 2",
    stroke: "#D1E5FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01172 61.524L51.0677 3.13672",
    stroke: "#195EB7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCanFee);
export default __webpack_public_path__ + "static/media/no_can_fee.5a9c58d636555385204e06ddca47e903.svg";
export { ForwardRef as ReactComponent };